import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Heading,
  useToast,
  Spinner,
  Alert,
  AlertIcon,
  Badge,
  Link,
  Select,
  Button,
  Flex,
  Stack,
  useDisclosure,
  useBreakpointValue,
} from "@chakra-ui/react";
import axios from "axios";
import Modal_student_fee_table from "./Modal_student_fee_table";

const Main_fee_table = () => {
  const [paidFees, setPaidFees] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [paymentStatusFilter, setPaymentStatusFilter] = useState("All");
  const toast = useToast();
  const studentId = sessionStorage.getItem("student_id");
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [transportInfo, setTransportInfo] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  //   useEffect(() => {
  //     fetchPaidFees();
  //   }, [studentId, paymentStatusFilter]);

  //   const fetchPaidFees = async () => {
  //     setIsLoading(true);
  //     setError(null);

  //     try {
  //       const response = await axios.post(
  //         `${BASE_URL}/student/bus/bus_fee_details.php`,
  //         {
  //           student_id: studentId,
  //           school_id: sessionStorage.getItem("school_id"),
  //         }
  //       );
  //       console.log("bus", response);

  //       if (response.data.success) {
  //         // Map the start_date to month format
  //         const allFees = response.data.data.map((fee) => ({
  //           ...fee,
  //           month: new Date(fee.start_date).toLocaleString("default", {
  //             month: "long",
  //             year: "numeric",
  //           }),
  //         }));

  //         // Filter based on payment status
  //         const filteredFees = allFees.filter((fee) => {
  //           if (paymentStatusFilter === "Paid") {
  //             return fee.payment_status === "Paid";
  //           } else if (paymentStatusFilter === "Unpaid") {
  //             return fee.payment_status === "Unpaid";
  //           }
  //           return true; // "All" status, no filter applied
  //         });

  //         // Sort so that unpaid fees come first
  //         const sortedFees = filteredFees.sort((a, b) => {
  //           if (a.payment_status === "Unpaid" && b.payment_status !== "Unpaid")
  //             return -1;
  //           if (a.payment_status !== "Unpaid" && b.payment_status === "Unpaid")
  //             return 1;
  //           return 0;
  //         });

  //         setPaidFees(sortedFees);
  //       } else {
  //         setError(response.data.message);
  //         toast({
  //           title: "Error",
  //           description: response.data.message,
  //           status: "error",
  //           duration: 5000,
  //           isClosable: true,
  //         });
  //       }
  //     } catch (err) {
  //       const errorMessage =
  //         err.response?.data?.message || "Failed to fetch paid fees";
  //       setError(errorMessage);
  //       toast({
  //         title: "Error",
  //         description: errorMessage,
  //         status: "error",
  //         duration: 5000,
  //         isClosable: true,
  //       });
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString();
  };

  const formatAmount = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
    }).format(amount);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const totalPages = Math.ceil(paidFees.length / rowsPerPage);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const paginatedFees = paidFees.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minH="200px"
      >
        <Spinner size="xl" color="blue.500" />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert status="error" borderRadius="md">
        <AlertIcon />
        {error}
      </Alert>
    );
  }

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handlePayButtonClick = (feeId) => {
    // Handle payment logic here for the unpaid fee
    console.log("Pay button clicked for feeId:", feeId);
    // Example: Call API or show modal to make payment
  };

  return (
    <Box w="100%">
      <div className="teacher-list-container">
        <div
          className="header"
          style={{ display: "flex", alignItems: "center" }}
        >
          <h1 style={{ fontSize: "20px", margin: 0 }}>
            Student & Teachers Bus Fee
          </h1>
        </div>

        <Box className="breadcrumb">
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Bus </span> /{" "}
          <Link
            to="/class/classlist"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Student and Teachers Bus Fee</span>
          </Link>
        </Box>
      </div>

      <Box p={6} flex="2" mb={1}>
        <Box>
          <Flex
            direction={isMobile ? "column" : "row"}
            justify={isMobile ? "start" : "space-between"}
            align="center"
            className="sb"
            mb={2}
            p={3}
          >
            <Box mb={isMobile ? 4 : 0}>
              <Flex align="center">
                <Text mr={2}>Rows Per Page</Text>
                <Select
                  width="100px"
                  value={rowsPerPage}
                  onChange={handleRowsPerPageChange}
                  borderColor="#E9EDF4"
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </Select>
              </Flex>
            </Box>
            <div className="action-buttons" style={{ marginLeft: "auto" }}>
              {/* Filter Dropdown for Payment Status */}
              <Select
                value={paymentStatusFilter}
                onChange={(e) => setPaymentStatusFilter(e.target.value)}
                borderColor="#E9EDF4"
                width="150px"
              >
                <option value="All">All</option>
                <option value="Paid">Paid</option>
                <option value="Unpaid">Unpaid</option>
              </Select>
            </div>
          </Flex>
          <Box overflowX="auto">
            <Table
              sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }}
            >
              <Thead>
                <Tr>
                  <Th>Month</Th>
                  <Th>Payment Date</Th>
                  <Th>Due Date</Th>
                  <Th>Amount</Th>
                  <Th>Fine</Th>
                  <Th>Payment Method</Th>
                  <Th>Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {paginatedFees.map((fee) => (
                  <Tr key={fee.fee_id}>
                    <Td>
                      <Text fontWeight="medium">{fee.month}</Text>
                      {fee.description && (
                        <Text fontSize="sm" color="gray.600">
                          {fee.description}
                        </Text>
                      )}
                    </Td>
                    <Td>{formatDate(fee.payment_date)}</Td>
                    <Td>{formatDate(fee.due_date)}</Td>
                    <Td>{formatAmount(fee.bus_fee)}</Td>
                    <Td>
                      {fee.fine_amount > 0 ? (
                        <Badge colorScheme="red">
                          {formatAmount(fee.fine_amount)}
                        </Badge>
                      ) : (
                        "-"
                      )}
                    </Td>
                    <Td>
                      <Badge colorScheme="green" borderRadius="full">
                        {fee.payment_method === 2
                          ? "Online"
                          : fee.payment_method === 1
                          ? "Cash"
                          : "Not Paid"}
                      </Badge>
                    </Td>
                    <Td>
                      {fee.payment_status === "Unpaid" && (
                        <Button
                          size="sm"
                          colorScheme="teal"
                          onClick={() => {
                            setTransportInfo(fee);
                            onOpen();
                          }}
                        >
                          Pay
                        </Button>
                      )}
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
          <Flex justify="end" className="sb2" borderTopWidth="1px" mt={1} p={3}>
            <Button
              onClick={() => handlePageChange(currentPage - 1)}
              isDisabled={currentPage === 1}
            >
              Prev
            </Button>
            <Stack direction="row" mx={2}>
              {currentPage > 1 && (
                <>
                  <Button onClick={() => handlePageChange(1)}>1</Button>
                  {currentPage > 2 && <Text>...</Text>}
                </>
              )}
              <Button backgroundColor="teal" color="white">
                {currentPage}
              </Button>
              {currentPage < totalPages - 1 && (
                <>
                  <Text>...</Text>
                  <Button onClick={() => handlePageChange(totalPages)}>
                    {totalPages}
                  </Button>
                </>
              )}
            </Stack>
            <Button
              onClick={() => handlePageChange(currentPage + 1)}
              isDisabled={currentPage === totalPages}
            >
              Next
            </Button>
          </Flex>
        </Box>
      </Box>
      {isOpen && (
        <Modal_student_fee_table
          isOpen={isOpen}
          onClose={onClose}
          amount={transportInfo.bus_fee}
          last={transportInfo.due_date}
          start={transportInfo.startDate}
          feeId={transportInfo.recordId}
        />
      )}
    </Box>
  );
};

export default Main_fee_table;
